<template>
  <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);">
    <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: calc(100% - 20px); height: 90%; background-color: white; border-radius: 10px; padding: 10px;">

      <div style="width: 100%; height: 50px; line-height: 50%; font-size: 20px; font-weight: bold; text-align: center">
        SHIPPING ADVICE [{{item.id}}] <span v-if="item.state === 100">[ 완료 ]</span>
      </div>
      <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">

        <table class="mani-table" style="width: 100%; font-size: small;">
          <tr>
            <td class="bold-text">Shipping Mode</td>
            <td colspan="2">
                <select class="form-control" v-model="item.shippingMode" @change="updateItem">
                  <option value="">Select</option>
                  <option v-for="mode in shippingModes" :value="mode">{{mode}}</option>
                </select>
            </td>
<!--            <td colspan="5">Please be advised that the shipment below has been consigned to your care</td>-->
            <td colspan="2">
              <input type="file" ref="bkNoDoc" style="display: none" v-on:change="addBkFilePickedUp($event, 'bkNoDoc')">
              <button class="btn btn-success" @click="onBkFileSelectorClick">Booking Ref & Waybill</button>
            </td>
            <td colspan="2">
              <button class="btn btn-primary" v-if="item.bkNoDoc !== null && item.bkNoDoc.startsWith('https://')" @click="bkNoDocView = item.bkNoDoc">Booking Ref & Waybill Doc 보기</button>
            </td>
            <td class="bold-text">House Ref</td>
            <td style="min-width: 250px;" colspan="6"><textarea v-model="item.bkNo" rows="3" class="form-control" @change="updateItem"/></td>
          </tr>
          <tr>
            <td class="bold-text">Cnt'r Size</td>
            <td colspan="2">
              <select class="form-control" v-model="item.containerSize" @change="updateItem">
                <option value="">Select</option>
                <option value="1x20 DR CNTR">1x20 DR CNTR</option>
                <option value="1x40 DR CNTR">1x40 DR CNTR</option>
                <option value="1x40 HQ CNTR">1x40 HQ CNTR</option>
                <option value="1x45 FT CNTR">1x45 FT CNTR</option>
              </select>

            </td>
            <td colspan="2" class="bold-text">Volume</td>
            <td colspan="2"><input type="number" v-model="item.cbmFloat" @change="updateItem"/></td>
            <td class="bold-text">ETD</td>
            <td colspan="2">
              <date-picker style="width: 100%; height: 38px; line-height: 38px;" v-model="item.etd" typable="false" placeholder="Select Date" valueType="format"  @change="updateItem"></date-picker>
            </td>
            <td class="bold-text">ETA</td>
            <td colspan="3">
              <date-picker style="width: 100%; height: 38px; line-height: 38px;" v-model="item.eta" typable="false" placeholder="Select Date" valueType="format" @change="updateItem(onEtaChanged)" ></date-picker>
            </td>
          </tr>
          <tr>
            <td class="bold-text">MBL No</td>
            <td colspan="2"><input type="text" class="form-control" v-model="item.mblNo" @change="updateItem"/></td>
            <td class="bold-text" colspan="2">Vessel / Voy</td>
            <td colspan="2"><input type="text" v-model="item.vessel" @change="updateItem"/></td>
            <td class="bold-text">Cnt'r No</td>
            <td colspan="2"><input type="text" v-model="item.containerNumber" @change="updateItem"/></td>
            <td class="bold-text">Seal No</td>
            <td colspan="3"><input type="text" class="form-control" v-model="item.sealNumber" @change="updateItem"/></td>
          </tr>

          <tr class="bold-text" style="background: #E2E2E2;">
            <td rowspan="2">Shipper</td>
            <td rowspan="2">H.B No</td>
            <td rowspan="2" style="max-width: 50px;">Qty</td>
            <td rowspan="2">CBM</td>
            <td rowspan="2">KG</td>
            <td colspan="6">Destination Charge</td>
            <td rowspan="2">CR(GBP)</td>
            <td rowspan="2">DR(GBP)</td>
            <td rowspan="2">Remarks</td>
          </tr>
          <tr class="bold-text" style="background: #E2E2E2;">
            <td>B/ T.S, D/O</td>
            <td>STR</td>
            <td>INS</td>
            <td>O/ LIFT</td>
            <td>DELIVERY</td>
            <td>FULL SET</td>
          </tr>
          <tbody v-for="(request, ri) in item.requests" style="border: 1px solid grey; border-top: 2px solid black;">
            <tr class="item-first-row">
              <td>{{request.requester}}</td>
              <td style="min-width: 150px;">
                <button class="btn btn-success form-control" v-if="request.hbNo === null || request.hbNo.length === 0" v-on:click="generateHbNo(ri)">HB No 생성하기</button>
                <label v-else class="form-control">{{request.hbNo}}</label>
              </td>
              <td style="max-width: 70px;"><input type="number" v-model="request.qty" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.cbmFloat" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.kg" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcDo" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcStr" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcIns" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcLift" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcDelivery" @change="updateRequestItem(ri)"/></td>
              <td style="max-width: 70px;"><input type="number" v-model="request.dcFullSet" @change="updateRequestItem(ri)"/></td>
              <td class="text-right" style="max-width: 70px;">
                <input type="number" v-model="request.cr" @change="updateRequestItem(ri)"/>
                <span v-if="item.exchangeUsd > 0"><br/>
                ${{(request.cr*item.exchangeUsd).toFixed(2)}}
                </span>
                  <span v-if="item.exchangeKrw > 0"><br/>
                  ₩{{(request.cr*item.exchangeKrw).toFixed(0)}}
                </span>
<!--                <label class="form-control text-right">{{(request.totalCredit/100.0).toFixed(2)}}</label>-->
              </td>
              <td class="text-right" style="max-width: 70px;">
                <input type="number" v-model="request.dr" @change="updateRequestItem(ri)"/>
                <span v-if="item.exchangeUsd > 0"><br/>
                ${{(request.dr*item.exchangeUsd).toFixed(2)}}
                </span>
                <span v-if="item.exchangeKrw > 0"><br/>
                  ₩{{(request.dr*item.exchangeKrw).toFixed(0)}}
                </span>
<!--                <label class="form-control text-right">{{(request.totalDebit/100.0).toFixed(2)}}</label>-->
              </td>
              <td>
<!--                <input v-model="request.remark" @change="updateRequestItem(ri)"/>-->
              </td>
            </tr>
            <tr>
              <td>
                Remark:
              </td>
              <td colspan="11">
                <input class="form-control" v-model="request.remark" @change="updateRequestItem(ri)"/>
              </td>
              <td colspan="2" rowspan="2">
                <button class="btn btn-danger" @click="unassignRequestItem(ri)">빼기</button>
              </td>
            </tr>
            <tr class="item-bottom-row">
              <td>
                Full Remark:
              </td>
              <td colspan="11">
                <textarea class="form-control" v-model="request.remarkFull" @change="updateRequestItem(ri)"/>
              </td>
            </tr>
          </tbody>
          <tr>
            <td colspan="4" rowspan="2" class="text-left" style="padding: 20px;"><button class="btn btn-primary" @click="getCandidates"><i class="fas fa-plus"></i> 추가하기</button></td>
            <td colspan="1">CUR</td>
            <td colspan="1" style="max-width: 70px;">£1:$</td>
            <td colspan="1" style="max-width: 70px;">£1:₩</td>
            <td colspan="7"></td>
          </tr>
          <tr>
            <td  style="max-width: 70px;">
              <select class="form-control" v-model="item.currency" @change="updateItem">
                <option value="GBP">£</option>
                <option value="USD">$</option>
                <option value="KRW">₩</option>
              </select>
            </td>
            <td style="max-width: 100px;">
              <input class="form-control" type="number" v-model="item.exchangeUsd" @change="updateItem"/>
            </td>
            <td style="max-width: 100px;">
              <input class="form-control" type="number" v-model="item.exchangeKrw" @change="updateItem"/>
            </td>
            <td colspan="7"></td>
          </tr>
          <tr>
            <th></th>
            <th></th>
            <th>{{item.qty}}</th>
            <th>{{item.cbmFloat}}</th>
            <th>{{item.kg}}</th>
            <th>{{item.dcDo}}</th>
            <th>{{item.dcStr}}</th>
            <th>{{item.dcIns}}</th>
            <th>{{item.dcLift}}</th>
            <th>{{item.dcDelivery}}</th>
            <th>{{item.dcFullSet}}</th>
            <th class="text-right">
              £{{(item.cr).toFixed(2)}}<br/>
              <span v-if="item.exchangeUsd > 0"><br/>
                ${{(item.cr*item.exchangeUsd).toFixed(2)}}
              </span>
              <span v-if="item.exchangeKrw > 0"><br/>
                ₩{{(item.cr*item.exchangeKrw).toFixed(0)}}
              </span>
            </th>
            <th class="text-right">
              £{{(item.dr).toFixed(2)}}<br/>
              <span v-if="item.exchangeUsd > 0"><br/>
                ${{(item.dr*item.exchangeUsd).toFixed(2)}}
              </span>
              <span v-if="item.exchangeKrw > 0"><br/>
                ₩{{(item.dr*item.exchangeKrw).toFixed(0)}}
              </span>
            </th>
          </tr>
        </table>

        <hr/>
        <div style="width: 100%; display: flex; margin-top: 20px;">
          <div style="width: 50%; padding:10px; background: #eee;">
            <strong>Loading Plan <button class="btn btn-success" @click="item.loadingPlan.push('')"><i class="fas fa-plus" ></i></button></strong>
            <table class="table">
              <tr>
                <td v-for="(p, pi) in item.loadingPlan">
                  <textarea class="form-control" v-model="item.loadingPlan[pi]" @change="updateItem"/>
                  <button class="btn btr-danger" @click="removeLoadingPlanItem(pi)"><i class="fas fa-trash"></i></button>
                </td>
<!--                <td>-->
<!--                  <button class="btn btn-primary" @click="updateItem"><i class="fas fa-save" ></i></button>-->

<!--                </td>-->
              </tr>

            </table>
          </div>
          <div style="min-height: 100px; width: 50%; padding:10px;">
            <strong>Note</strong>
            <textarea v-model="item.remarks" class="form-control" rows="5" @change="updateItem">
            </textarea>
          </div>
        </div>

        <hr/>
        <div style="margin-top: 20px; text-align: left;">
          <div style="margin-top: 20px; font-size: 20px; font-weight: bold;">Master Bill</div>
          <button class="btn btn-primary" v-if="item.masterBill !== null && item.masterBill.startsWith('https://')"
                  @click="bkNoDocView = item.masterBill">Master bill 보기</button>
          <input type="file" ref="masterBill" style="display: none" v-on:change="addBkFilePickedUp($event, 'masterBill')">
          <button class="btn btn-success" @click="onMasterBillFileSelectorClick"><i class="fas fa-upload"></i></button>
        </div>
        <div style="margin-top: 20px; text-align: left;" v-if="item.id > 0">
          <div style="margin-top: 20px; font-size: 20px; font-weight: bold;">Documents</div>

          <table class="table">
            <tr>
              <th>Title</th>
              <th></th>

            </tr>
            <tbody v-for="d in item.documents" v-bind:key="'main-doc-' + d.id">
            <tr>
              <td><input v-model="d.title" class="form-control" @change="updateDocumentItem(d)"/></td>
              <td>
                <button class="btn btn-info"  @click="bkNoDocView = d.url">View</button>
                <button class="btn btn-danger" style="margin-left: 20px;" @click="deleteDocument(d.id)"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
          <input type="file" ref="document" style="display: none" v-on:change="onDocumentSelected($event)">
          <button class="btn btn-success" @click="onDocumentSelectorClick"><i class="fas fa-upload"></i> Add New Document</button>
        </div>
        <div style="margin-top: 20px; font-size: 20px; font-weight: bold;">B/L Instruction</div>
        <table class="table text-left">
          <tr>
            <td colspan="2" style="width: 50%;">
              Shipper
              <input class="form-control" v-model="item.shipper" @change="updateItem"/>
              <textarea class="form-control" rows="5" v-model="item.shipperAddress" @change="updateItem"/>
            </td>
            <td rowspan="4">
              EXPORT FEF. NO
              <input class="form-control" v-model="item.exportFefNo" @change="updateItem"/>

              TO:
              <input class="form-control" v-model="item.instructionTo" @change="updateItem"/>
              <table style="width: 100%;">
                <tr>
                  <td style="width:40%;">
                    <label class="form-control">FM: UKO SHIPPING /</label>
                  </td>
                  <td>
                    <input class="form-control" v-model="item.issuer" @change="updateItem"/>
                  </td>
                </tr>
              </table>



              Booking REF:
              <input class="form-control" v-model="item.bkNo" disabled/>

              Memo:
              <textarea v-model="item.blInstructionMemo" @change="updateItem" class="form-control" rows="3"/>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="width: 50%;">
              Consignee
              <select class="form-control" v-model="item.consigneeId" @change="onConsigneeIdChanged">
                <option value="0">Select</option>
                <option v-for="c in customers" v-bind:key="'consignee-candidate-'+c.id" :value="c.id">{{c.title}}</option>
              </select>
              <input class="form-control" v-model="item.consignee" @change="updateItem"/>
              <textarea class="form-control" rows="5" v-model="item.consigneeAddress" @change="updateItem"/>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="width: 50%;">
              Notify Party
              <select class="form-control" v-model="item.notifyId" @change="onNotifyIdChanged">
                <option value="0">Select</option>
                <option v-for="c in customers" v-bind:key="'consignee-candidate-'+c.id" :value="c.id">{{c.title}}</option>
              </select>
              <textarea class="form-control" rows="5" v-model="item.notifyParty" @change="updateItem"/>
            </td>
          </tr>
          <tr>
            <td style="width:25%;">
              Vessel Voy
              <input class="form-control" v-model="item.vessel" disabled/>
            </td>
            <td>
              Port of Loading
              <input class="form-control" v-model="item.portOfLoading" @change="updateItem"/>
            </td>
          </tr>
          <tr>
            <td>
              Port of Discharge
              <input class="form-control" v-model="item.portOfDischarge" @change="updateItem"/>
            </td>
            <td>
              Place of Delivery
              <input class="form-control" v-model="item.placeOfDelivery" @change="updateItem"/>
            </td>
            <td>

            </td>
          </tr>
        </table>
        <table class="table">
          <tr>
            <th>MARKS AND NUMBERS</th>
            <th>NO. OF CONT<br/>OR OTHER PKGS</th>
            <th>DESCRIPTION OF PACKAGES<br/>AND GOODS</th>
            <th>GROSS WEIGHT</th>
            <th>MEASUREMENT</th>
          </tr>
          <tr>
            <td>
              {{item.containerNumber}} / {{item.sealNumber}}
            </td>
            <td>
              {{item.qty}} PKGS
            </td>
            <td>
              SHIPPER'S LOAD AND COUNT
              <br/>
              SAID TO CONTAIN
              <br/>
              {{item.containerSize}}
<!--              <input class="form-control" v-model="item.containerSize" @change="updateItem"/>-->
            </td>
            <td>
              {{item.kg}} KG
            </td>
            <td>
              {{item.cbmFloat}} CBM
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-center">
            {{item.qty}} <input style="width: calc(100% -  100px);" v-model="item.goodsDescription" @change="updateItem"/>
              <br/>
              HS CODE : <input style="width: 200px;" v-model="item.hsCode" @change="updateItem"/>
              <BR/>
              TERMS:<input style="width: 200px;" v-model="item.terms" @change="updateItem"/>
            </td>

          </tr>
          <tr>
            <td/><td/>
            <td>
              Additional
              <textarea class="form-control" v-model="item.blAdditionalPackages" rows="3" @change="updateItem">

              </textarea>
            </td>
            <td/><td/>
          </tr>
        </table>
        <div class="container">
          <div class="row">
            <div class="col-6">
              <button class="btn btn-primary" @click="generateBlInstruction">BL INSTRUCTION PDF</button>
            </div>
            <div class="col-6"></div>
          </div>
        </div>



      </div>
      <div style="width: 100%; height: 50px; display:flex; line-height: 50px; font-size: 20px; font-weight: bold; text-align: right; background: #CACACA;">
        <div style="width: 30%; height: 50px; padding: 0 20px 0 20px; text-align: left;">
          <button class="btn btn-dark" @click="closeItem">Close</button>
          <button v-if="item.id > 0" class="btn btn-danger" style="margin-left: 50px;" @click="deleteItem">삭제</button>
        </div>
        <div style="width: 70%; height: 50px; padding: 0 20px 0 20px; text-align: right;">
          <button v-if="item.id === 0" class="btn btn-primary" @click="createItem">Create</button>
          <template v-if="item.id > 0" >
            <button class="btn btn-primary" @click="completeItem">완료처리하기</button>


            <button class="btn btn-primary" style="margin-right: 20px;" @click="generateBlInstruction($event, false)">BL INSTRUCTION PDF</button>
            <button class="btn btn-success" @click="generateShippingAdvice($event, false)">Shipping Advice</button>
            <button class="btn btn-primary" @click="onEtaChanged">Status Email</button>
            <button class="btn btn-danger" @click="openEmailItem">EMAIL</button>
          </template>

        </div>



      </div>
    </div>
    <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);" v-if="candidateView !== false" @click="candidateView = false">
      <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: 500px; height: 70%; background-color: white; border-radius: 10px; padding: 10px;" v-on:click.stop="dummy">
        <div style="width: 100%; height: 50px; line-height: 50px; font-weight: bold; font-size: 20px;">
          이사 리스트 <input id="search-input" v-model="candidateView.searchWord" style="width:200px;" @change="searchList"/>
        </div>
        <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
          <ul class="list-group">
            <li class="list-group-item" style="cursor: pointer;" v-for="request in candidateView.requests" v-on:click="selectRequest(request)">
              <div>REF: {{request.reference}} [{{request.id}}]</div>
              <div>고객: {{request.requester}}</div>
              <div>이사일: {{request.packingDate}}</div>
              <div>전화: {{request.phoneNumber}}</div>
              <div>위치: {{request.addressFrom}}</div>
              <div>CBM: {{request.preCbm}}</div>

            </li>
          </ul>
        </div>
      </div>
    </div>
    <transition name="slideup">
      <div class="item-container" v-if="bkNoDocView != false" v-on:click="bkNoDocView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:calc(100% - 300px); height:100%; padding-top:10px;">
            <embed :src="bkNoDocView" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
          </div>
          <div style="width:300px; height:100%; overflow-y: scroll; padding:20px; text-align: left;">

          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="blInstructionView != false" v-on:click="blInstructionView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:calc(100% - 300px); height:100%; padding-top:10px;">
            <embed :src="blInstructionView" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
          </div>
          <div style="width:300px; height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h4>BL Instruction</h4>
            <button class="btn btn-primary" @click="generateBlInstruction($event, true)">BL Instruction 다시 생성</button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="shippingAdviceView != false" v-on:click="shippingAdviceView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:calc(100% - 300px); height:100%; padding-top:10px;">
            <embed :src="shippingAdviceView" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
          </div>
          <div style="width:300px; height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h4>Shipping Advice</h4>
            <button class="btn btn-primary" @click="generateShippingAdvice($event, true)">Shipping Advice 다시 생성</button>
          </div>
        </div>
      </div>
    </transition>
    <email-form v-if="emailItem !== false"
                :item="emailItem.item"
                :documents="emailItem.documents"
                :on-close="closeEmailItem">

    </email-form>
    <template v-if="pdfItem !== false">
      <transition name="slideup">
        <pdf-viewer
          :item="pdfItem"
          :on-close="closePdfViewer">

        </pdf-viewer>
      </transition>
    </template>
  </div>
</template>

<script>
import {generateOrderNumber, millisToDate, showDialog} from "../api/utils";
  import {
    deleteManifest,
    getBlInstructionPDF,
    getManifestRequestCandidates,
    getShippingAdvicePDF,
    updateManifest
  } from "../api/manifests";
  import {
    getShippingMode,
    updateRequest,
    generateRequestHbNo,
    searchRequests,
    sendEmailLinkToCustomer
  } from "../api/request";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {getLadingPDF} from "../api/houses";
  import FileDownload from "js-file-download";
  import firebase from "firebase";
  import "firebase/auth";
  import "firebase/storage";
  import moment from 'moment';
  import EventBus from "../api/event-bus";
  import {deleteDocument, updateDocument} from "../api/documents";
  import EmailForm from "./EmailForm";
  import PdfViewer from "./PdfViewer";
  export default {
    name: "ManifestItemView",
    data() {
      return {
        requests:[],
        shippingModes:getShippingMode(),
        candidateView: false,
        bkNoDocView:false,
        blInstructionView:false,
        shippingAdviceView:false,
        emailItem:false,
        pdfItem: false,
      }
    },
    props: {
      item: {
        type:Object,
        default: function(){return null;}
      },
      customers: {
        type:Array,
        default: function(){return [];}
      },
      onUpdated: {
        type:Function,
        default:null,
      },
      onClose: {
        type: Function,
        default:null,
      },
      onDeleted: {
        type: Function,
        default:null,
      }
    },
    components: {
      EmailForm,
      DatePicker,
      PdfViewer,
    },
    created() {
    },
    mounted() {
      this.checkDefault();
    },
    methods: {

      // onClose: function() {
      //   if(this.onClose !== null) {
      //     this.onClose();
      //   }
      // },
      dummy: function() {
        console.log("dummy");
      },
      openEmailItem: function() {
        let documents = [];
        console.log("open email");
        console.log(this.item);

        if(this.item.bkNoDoc !== null && this.item.bkNoDoc.length > 0) {
          documents.push({
            title: 'BookingRef-WayBill',
            url:this.item.bkNoDoc,
          });
        }
        if(this.item.masterBill !== null && this.item.masterBill.length > 0) {
          documents.push({
            title: 'master bill',
            url:this.item.masterBill,
          });
        }

        if(this.item.blInstructionDoc !== null && this.item.blInstructionDoc.length > 0) {
          documents.push({
            title: 'BL Instruction',
            url: this.item.blInstructionDoc
          });
        }
        if(this.item.shippingAdviceDoc !== null && this.item.shippingAdviceDoc.length > 0) {
          documents.push({
            title: 'Shipping Advice',
            url: this.item.shippingAdviceDoc,
          })
        }
        for(let i = 0 ; i < this.item.documents.length ; i++) {
          documents.push(this.item.documents[i]);
        }

        let orderNumber = generateOrderNumber();
        for(let i = 0 ; i < this.item.requests.length ; i++) {
          if(this.item.requests[i].surveyForm !== null && this.item.requests[i].surveyForm !== null && this.item.requests[i].surveyForm.length > 0) {
            documents.push({
              title: "SurveyForm" + '-' + this.item.requests[i].requester + '-' + orderNumber,
              url: this.item.requests[i].surveyForm,
            })
          }
          if(this.item.requests[i].quotation !== null && this.item.requests[i].quotation.url !== null && this.item.requests[i].quotation.url.length > 0) {
            documents.push({
              title: this.item.requests[i].quotation.type.toUpperCase() + '-' + this.item.requests[i].quotation.shippingMode + '-' + this.item.requests[i].quotation.requester + '-' + (this.item.requests[i].quotation.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
              url: this.item.requests[i].quotation.url,
            })
          }
          if(this.item.requests[i].invoice !== null && this.item.requests[i].invoice.url !== null && this.item.requests[i].invoice.url.length > 0) {
            documents.push({
              title: this.item.requests[i].invoice.type.toUpperCase() + '-' + this.item.requests[i].invoice.shippingMode + '-' + this.item.requests[i].requester + '-' + (this.item.requests[i].invoice.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
              url: this.item.requests[i].invoice.url,
            })
          }

          if(this.item.requests[i].packingListDoc !== null && this.item.requests[i].packingListDoc.length > 0) {
            documents.push({
              title: 'Packing-List-' + this.item.requests[i].requester + '-' + this.item.requests[i].hbNo + '-' + this.item.requests[i].qty + '-' + orderNumber,
              url: this.item.requests[i].packingListDoc,
            });
          }
          if(this.item.requests[i].house !== null && this.item.requests[i].house.url !== null && this.item.requests[i].house.url.length > 0) {
            documents.push({
              title: this.item.requests[i].house.blNumber + '-' + this.item.requests[i].house.shipperTitle + '-' + orderNumber,
              url:this.item.requests[i].house.url,
            });
          }


          if(this.item.requests[i].packingInvoice !== null && this.item.requests[i].packingInvoice.length > 0) {
            documents.push({
              title:'Packing-Invoice-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].packingInvoice
            })
          }
          if(this.item.requests[i].approvalLetter !== null && this.item.requests[i].approvalLetter.length > 0) {
            documents.push({
              title:'Approval-Letter-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].approvalLetter
            })
          }

          if(this.item.requests[i].psid !== null && this.item.requests[i].psid.length > 0) {
            documents.push({
              title:'PSID-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].psid
            })
          }
          if(this.item.requests[i].commercialInvoice !== null && this.item.requests[i].commercialInvoice.length > 0) {
            documents.push({
              title:'Commercial-Invoice-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].commercialInvoice
            })
          }
          if(this.item.requests[i].tncAgreement !== null && this.item.requests[i].tncAgreement.length > 0) {
            documents.push({
              title:'TnC-Agreement-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].tncAgreement
            })
          }
          if(this.item.requests[i].reasonStatement !== null && this.item.requests[i].reasonStatement.length > 0) {
            documents.push({
              title:'Reason-Statement-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].reasonStatement
            })
          }
          if(this.item.requests[i].packingInvoiceItem !== null && this.item.requests[i].packingInvoiceItem.documentUrl !== null && this.item.requests[i].packingInvoiceItem.documentUrl.length > 0) {
            documents.push({
              title:'Packing-Invoice-' + this.item.requests[i].requester  + '-' + orderNumber,
              url: this.item.requests[i].packingInvoiceItem.documentUrl,
            })
          }
        }
        let to = "";
        if(this.item.notifyParty !== null && this.item.notifyParty.length > 0) {
          let lines = this.item.notifyParty.split("\n");
          for(let i = 0 ; i < lines.length ; i++) {
            // console.log(lines[i]);
            if(lines[i].startsWith("EMAIL: ")) {
              let emails = lines[i].replace("EMAIL: ", "");
              if(emails !== null && emails.length > 0) {
                to = emails.replaceAll(" ", "").toLowerCase();
              }
            }
          }
        }

        this.$data.emailItem = {
          item: {
            to:to,
            subject:'UKO Shipping Manifest ' + this.item.mblNo,
            body:'안녕하세요 UKO Shipping입니다.\n',
            documents:[],
          },
          documents:documents,
        }
      },
      closeEmailItem: function() {
        this.$data.emailItem = false;
      },
      checkDefault: function() {
        let toUpdate = false;
        if(this.item.shipper === null || this.item.shipper === '') {
          this.item.shipper = "UKO SHIPPING";
          toUpdate = true;
        }
        if(this.item.shipperAddress === null || this.item.shipperAddress === '') {
          this.item.shipperAddress = '13 OAKFIELD AVENUE\nCIPPENHAM\nSLOUGH\nSL1 5AE\nTEL: 01753 578 171';
          toUpdate = true;
        }
        if(this.item.consignee === null || this.item.consignee === '') {
          this.item.consignee = "OKSHIPPING";
          toUpdate = true;
        }
        if(this.item.consigneeAddress === null || this.item.consigneeAddress === '') {
          this.item.consigneeAddress = '26 BUNGIL, 61 GANGCHON RO\nILSAN DONGGU, GOYANGSI, KYOUNGGI DO, KOREA\nTEL: 02 333 2422 Email: kang395600@naver.com';
          toUpdate = true;
        }
        if(this.item.notifyParty === null || this.item.notifyParty === '') {
          this.item.notifyParty = "SAME AS CONSIGNEE";
          toUpdate = true;
        }
        if(this.item.goodsDescription === null || this.item.goodsDescription === '') {
          this.item.goodsDescription = "C/T BOXES OF USED HOUSEHOULD GOODS & PERSONAL EFFECTS";
          toUpdate = true;
        }
        if(this.item.terms === null || this.item.terms === '') {
          this.item.terms = "CY/CY";
          toUpdate = true;
        }
        if(this.item.instructionTo === null || this.item.instructionTo === '') {
          this.item.instructionTo = "HMM";
          toUpdate = true;
        }

        if(toUpdate === true) {
          this.updateItem();
        }
      },
      removeLoadingPlanItem: function(index) {
        if(this.item.loadingPlan.length <= index) {
          return;
        }
        this.item.loadingPlan.splice(index, 1);
        this.updateItem();
      },
      deleteItem: function() {
        let self = this;
        this.$modal.show('dialog', {
          //title: '로그아웃',
          text: '현재 Manifest를 삭제하시겠습니까?',
          buttons: [
            {
              title: '아니요',
              handler: () => {
                self.$modal.hide('dialog');

              }
            },
            {
              title: '지우기',
              handler: () => {
                self.$modal.hide('dialog');

                self.deleteItemConfirmed();
              }
            },

          ]

        });
      },
      deleteItemConfirmed: function() {

        let self = this;
        deleteManifest(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            console.log("delete item");
            console.log(data);
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          showDialog(err, "ERROR");
        })
      },
      completeItem: function() {
        let self = this;
        if(this.item.id === 0) {
          return;
        }
        this.item.state = 100;
        updateManifest(this.item)
          .then(function(data) {
            if(data.success === true) {
              if(self.onUpdated !== null) {
                self.onUpdated(data.item);
              }
              if(self.onClose !== null) {
                self.onClose();
              }
            } else {
              showDialog(data.message || 'Failed to complete manifest.', 'ERROR');
            }
          })
          .catch(function(err) {
            showDialog((err && err.message) ? err.message : String(err), 'ERROR');
          })
      },
      onConsigneeIdChanged: function() {
        this.item.consignee = '';
        this.item.consigneeAddress = '';

        for(let i = 0 ; i < this.customers.length ; i++) {
          console.log(this.customers[i].id + " vs " + this.item.consigneeId);
          if(this.customers[i].id === this.item.consigneeId) {
            this.item.consignee = this.customers[i].title;
            this.item.consigneeAddress = this.customers[i].address;
            if(this.customers[i].contact !== null && this.customers[i].contact.length > 0) {
              this.item.consigneeAddress += '\nTEL: ' + this.customers[i].contact;
            }
            if(this.customers[i].email !== null && this.customers[i].email.length > 0) {
              this.item.consigneeAddress += '\nEMAIL: ' + this.customers[i].email;
            }
            break;
          }
        }
        this.updateItem();
      },
      onNotifyIdChanged: function() {
        this.item.notifyParty = '';
        // this.item.consigneeAddress = '';

        if(this.item.notifyId === 0) {
          this.item.notifyParty = 'SAME AS CONSIGNEE';
          this.updateItem();
          return;
        }
        for(let i = 0 ; i < this.customers.length ; i++) {
          console.log(this.customers[i].id + " vs " + this.item.notifyId);
          if(this.customers[i].id === this.item.notifyId) {
            this.item.notifyParty = this.customers[i].title;
            if(this.customers[i].address !== null && this.customers[i].address.length > 0) {
              this.item.notifyParty += '\n' + this.customers[i].address;
            }
            if(this.customers[i].contact !== null && this.customers[i].contact.length > 0) {
              this.item.notifyParty += '\nTEL: ' + this.customers[i].contact;
            }
            if(this.customers[i].email !== null && this.customers[i].email.length > 0) {
              this.item.notifyParty += '\nEMAIL: ' + this.customers[i].email;
            }
            break;
          }
        }
        this.updateItem();
      },
      updateItem: function(nextFn = null) {
        let self = this;
        if(this.item.id === 0) {
          return;
        }
        this.item.cbm = Math.round(parseFloat(this.item.cbmFloat) * 100);
        if(this.item.loadingPlan !== null && this.item.loadingPlan.length > 0) {
          for(let i = 0 ; i < this.item.loadingPlan.length ; i++) {
            this.item.loadingPlan[i] = this.item.loadingPlan[i].replace(/,/g, "\\,");
          }
          console.log(JSON.stringify(this.item.loadingPlan));

        }

        updateManifest(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            // @change="updateItem" passes the DOM event (or a date string).
            // Only the ETA field passes a real callback.
            if(typeof nextFn === 'function') {
              nextFn();
            }
          } else {
            showDialog(data.message || 'Failed to save manifest.', 'ERROR');
          }
        })
        .catch(function(err) {
          showDialog((err && err.message) ? err.message : 'Failed to save manifest.', 'ERROR');
        })
      },
      createItem: function() {
        console.log("create item");

        // let today = millisToDate(new Date().getTime());
        // if(this.item.etd === null || this.item.etd < today) {
        //   console.log("etd required");
        //   showDialog("ETD required. Cannot be earlier than today");
        //   return;
        // }

        let self = this;
        updateManifest(this.item)
        .then(function(data) {
          console.log(data);
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message || 'Failed to create manifest.', 'ERROR');
          }
        })
        .catch(function(err) {
          showDialog((err && err.message) ? err.message : 'Failed to create manifest.', 'ERROR');
        })
      },
      closeItem: function() {
        if(this.onClose !== null) {
          this.onClose();
        }
      },
      openShippingAdvice: function() {
        let date = millisToDate(new Date(), '-');

        let emailForm = {
          to: this.item.invoiceToEmail,
          subject:this.item.mblNo.toUpperCase() + 'Shipping Advice ' + date,
          body: '안녕하세요 UKO Shipping입니다.\n',
          documents:[{
            title:this.item.mblNo.toUpperCase() + '-ShippingAdvice-' + (this.item.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
            url:this.item.shippingAdviceDoc,
          }]
        }
        this.$data.pdfItem = {
          url: this.item.shippingAdviceDoc,
          title: this.item.mblNo.toUpperCase() + ' ShippingAdvice',
          emailForm: emailForm,
          regenerateFn: this.generateShippingAdvice,
        }
      },
      generateShippingAdvice: function(e, force = true) {
        let self = this;
        console.log(force);
        console.log("force " + force + " url = " + this.item.shippingAdviceDoc);
        if(force === false && this.item.shippingAdviceDoc !== null && this.item.shippingAdviceDoc.length > 0) {
          this.openShippingAdvice();
          return;
        }
        getShippingAdvicePDF(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.item.shippingAdviceDoc = data.item.shippingAdviceDoc;
            self.openShippingAdvice();
          } else {
            showDialog(data.message);
          }
          // FileDownload(response.data, 'SHIPPING-ADVICE-' + self.item.id + ".pdf");
        })
        .catch(function(err) {
          let msg = err;
          console.log(err);
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
            console.log(err.response);
          }

          showDialog(msg, "ERROR");
        })
      },
      openBlInstruction: function() {
        let date = millisToDate(new Date(), '-');

        let emailForm = {
          to: this.item.invoiceToEmail,
          subject:this.item.mblNo.toUpperCase() + ' BL Instruction ' + date,
          body: '안녕하세요 UKO Shipping입니다.\n',
          documents:[{
            title:this.item.mblNo.toUpperCase() + '-BLInstruction-' + (this.item.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
            url:this.item.blInstructionDoc,
          }]
        }
        this.$data.pdfItem = {
          url: this.item.blInstructionDoc,
          title: this.item.mblNo.toUpperCase() + ' BLInstruction',
          emailForm: emailForm,
          regenerateFn: this.generateBlInstruction,
        }
      },
      generateBlInstruction: function(e, force = true) {
        let self = this;
        console.log("force " + force + " url = " + this.item.blInstructionDoc);
        if(force === false && this.item.blInstructionDoc !== null && this.item.blInstructionDoc.length > 0) {
          this.openBlInstruction();
          return;
        }
        getBlInstructionPDF(this.item.id)
          .then(function(data) {
            if(data.success === true) {
              self.item.blInstructionDoc = data.item.blInstructionDoc;
              // self.$data.blInstructionView = self.item.blInstructionDoc;
              self.openBlInstruction();
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            console.log(err);
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
              console.log(err.response);
            }

            showDialog(msg, "ERROR");
          })
      },
      unassignRequestItem: function(index) {

        this.item.requests[index].manifestId = 0;
        this.updateRequestItem(index);
      },
      generateHbNo: function(index) {

        let self = this;
        generateRequestHbNo(this.item.requests[index].id)
        .then(function(data) {
          if(data.success ===  true) {
            self.item.requests.splice(index, 1, data.item);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      },
      updateRequestItem: function(index) {
        let self = this;
        this.item.requests[index].cr = parseInt(this.item.requests[index].dcDo) + parseInt(this.item.requests[index].dcStr)
          + parseInt(this.item.requests[index].dcIns) + parseInt(this.item.requests[index].dcLift)
          + parseInt(this.item.requests[index].dcDelivery) + parseInt(this.item.requests[index].dcFullSet);
        this.item.requests[index].cbm = Math.round(parseFloat(this.item.requests[index].cbmFloat) * 100);
        updateRequest(this.item.requests[index])
        .then(function(data) {
          if(data.success === true) {
            if(data.item.manifestId === self.item.id) {
              self.item.requests.splice(index, 1, data.item);
            } else {
              self.item.requests.splice(index, 1);
            }
            self.onRequestItemUpdated();
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
      },
      getCandidates: function() {
        let self = this;
        this.$data.candidateView = {
          requests:[],
          searchWord:'',
        };


      },
      searchList: function() {
        if(this.$data.candidateView.searchWord === null || this.$data.candidateView.searchWord.length < 2) {
          return;
        }
        let query = "stateFrom=0&stateTo=99&manifestId=0&searchName=" + this.$data.candidateView.searchWord;
        let self = this;
        searchRequests(query)
          .then(function(data) {
            console.log(data);
            if(data.success == true) {

              self.$data.candidateView.requests = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
      selectRequest: function(request) {
        request.manifestId = this.item.id;
        this.item.requests.push(request);
        this.$data.candidateView = false;

        let bkNoList = [];
        for(let i = 0 ; i < this.item.requests.length ; i++) {
          let cbm = this.item.requests[i].cbm;
          if(this.item.requests[i].cbm === 0 && this.item.requests[i].preCbm > 0) {
            cbm = this.item.requests[i].preCbm
          }
          bkNoList.push(this.item.requests[i].requester +  cbm  + '-' + this.item.requests[i].urnCode);
        }
        if(bkNoList.length > 0) {
          this.item.bkNo = bkNoList.join(', ');
        }
        this.updateRequestItem(this.item.requests.length -1);

      },
      deselectRequest: function(index) {
        this.item.requests[index].manifestId = 0;
        this.item.requests[index].hbNo = '';
        this.updateRequestItem(index);

      },
      onRequestItemUpdated: function() {
        this.item.cbm = 0;
        this.item.cbmFloat = 0.0;
        this.item.kg = 0;
        this.item.qty = 0;
        this.item.dcDo = 0;
        this.item.dcStr = 0;
        this.item.dcIns = 0;
        this.item.dcLift = 0;
        this.item.dcDelivery = 0;
        this.item.dcFullSet = 0;
        this.item.cr = 0;
        this.item.dr = 0;

        for(let i = 0 ; i < this.item.requests.length ; i++) {
          this.item.cbmFloat += parseFloat(this.item.requests[i].cbmFloat);
          this.item.cbm += this.item.requests[i].cbm;
          this.item.kg += this.item.requests[i].kg
          this.item.qty += this.item.requests[i].qty;
          this.item.dcDo += this.item.requests[i].dcDo;
          this.item.dcStr += this.item.requests[i].dcStr;
          this.item.dcIns += this.item.requests[i].dcIns;
          this.item.dcLift += this.item.requests[i].dcLift;
          this.item.dcDelivery += this.item.requests[i].dcDelivery;
          this.item.dcFullSet += this.item.requests[i].dcFullSet;
          this.item.cr += this.item.requests[i].cr;
          this.item.dr += this.item.requests[i].dr;
        }

        this.updateItem();
      },
      onBkFileSelectorClick: function() {
        this.$refs.bkNoDoc.value = "";
        this.$refs.bkNoDoc.click()
      },
      onDocumentSelectorClick: function() {
        this.$refs.document.value = "";
        this.$refs.document.click()
      },
      onMasterBillFileSelectorClick: function() {
        this.$refs.masterBill.value = "";
        this.$refs.masterBill.click()
      },
      addBkFilePickedUp: function(e, field) {
        // const uploader = document.getElementById('uploader-' + field);
        //get file
        console.log("File Btn Added");
        console.log(e);
        let getFile = e.target.files[0];
        console.log("File name - " + getFile.name);
        //set storage ref
        let d = new Date();
        let name  =  moment(d).format('YYYYMMDD-hhmmss');
        let names = getFile.name.split('.');

        let path = 'manifest-' + this.item.id + "/doc/" + field + '/'  + name + '.' + names[names.length-1];
        let storageRef = firebase.storage().ref();
        let mountainsRef = storageRef.child(path);
        let self = this;
        EventBus.$emit("showLoading", true);
        mountainsRef.put(getFile).on('state_changed',
          function progress(snapshot){

            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
            console.log("percentage " + percentage);
            // uploader.value = percentage;
          },
          function error(err){
            EventBus.$emit("showLoading", false);
            console.log(err);
          },
          function complete(){
            EventBus.$emit("showLoading", false);
            console.log('complete upload');
            self.item[field] = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;

            self.updateItem();
            // self.updateEditGoodItem();
          }
        );
      },
      deleteDocument: function(id) {
        let self = this;
        deleteDocument(id)
          .then(function(data) {
            if(data.success === true) {
              for(let i = 0 ; i < self.item.documents.length ; i++) {
                if(self.item.documents[i].id === data.item.id) {
                  self.item.documents.splice(i, 1);
                  return;
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
      updateDocumentItem: function(item) {
        let self = this;
        updateDocument(item)
          .then(function(data) {
            if(data.success === true) {
              for(let i = 0 ; i < self.item.documents.length ; i++) {
                if(self.item.documents[i].id === data.item.id) {
                  self.item.documents.splice(i, 1, data.item);
                  return;
                }
              }
              self.item.documents.push(data.item);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
      onDocumentSelected: function(e) {
        // const uploader = document.getElementById('uploader-' + field);
        //get file
        console.log("File Btn Added");
        console.log(e);
        let getFile = e.target.files[0];
        console.log("File name - " + getFile.name);
        //set storage ref
        let d = new Date();
        let name  =  moment(d).format('YYYYMMDD-hhmmss');
        let names = getFile.name.split('.');

        let path = 'manifest-' + this.item.id + "/docs/"  + name + '.' + names[names.length-1];
        let storageRef = firebase.storage().ref();
        let mountainsRef = storageRef.child(path);
        let self = this;
        EventBus.$emit("showLoading", true);
        mountainsRef.put(getFile).on('state_changed',
          function progress(snapshot){

            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
            console.log("percentage " + percentage);
            // uploader.value = percentage;
          },
          function error(err){
            EventBus.$emit("showLoading", false);
            console.log(err);
          },
          function complete(){
            EventBus.$emit("showLoading", false);
            console.log('complete upload');
            let documentUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;

            let documentItem = {
              id:0,
              manifestId: self.item.id,
              type:'document',
              url:documentUrl,
              title:'',
              description:'',
            }
            self.updateDocumentItem(documentItem);
            // self.updateEditGoodItem();
          }
        );
      },
      onEtaChanged: function() {
        // if(this.item.shippingMode === 'AIR IN' || this.item.shippingMode === 'SEA IN') {
        //   return;
        // }
        let self = this;
        this.$modal.show('dialog', {
          //title: '로그아웃',
          text: '고객에게 Status 업데이트 이메일을 보내시겠습니까?',
          buttons: [
            {
              title: '아니요',
              handler: () => {
                self.$modal.hide('dialog');

              }
            },
            {
              title: '보내기',
              handler: () => {
                self.$modal.hide('dialog');

                self.sendStatusEmail(0);
              }
            },

          ]

        });
      },

      sendStatusEmail: function(index, message = '') {
        console.log("sendStatusEmail " + index + " message " + message);
        if(index >= this.item.requests.length) {
          if(message.length > 0) {
            showDialog(message);
          }
          return;
        }

        let self = this;
        sendEmailLinkToCustomer(self.item.requests[index].id)
          .then(function(data) {
            if(data.success == true) {
              self.sendStatusEmail(index+1, message+ self.item.requests[index].hbNo + " status email sent<br/>");
            } else {
              self.sendStatusEmail(index+1, message+ '<span style="color:red;">' + self.item.requests[index].hbNo + " Failed to send due to " + data.message + "</span><br/>");
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg);
          })
      },
      closePdfViewer: function() {
        this.$data.pdfItem = false;
      }
    }
  }
</script>

<style scoped>
.item-first-row > td {
  margin-top: 10px;
  padding-top: 10px;
}
.item-bottom-row > td{
  margin-bottom: 10px;
}
.item-container {
  position: fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  /*float: left;*/
  /*width: calc(100% - 700px);*/
  /*height: 100%;*/
  /*overflow-y: scroll;*/
  /*background: green;*/
}
</style>



// WEBPACK FOOTER //
// src/components/ManifestItemView.vue